import { useDispatch, useSelector } from "react-redux";
import LeadrOrderDetail from './LeadrOrderDetail'
import {selectors} from "redux/PurchaseOrder";
import { useCallback, useEffect, useState } from "react";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import { CONSTANTS } from "client/utils/constants";
import { formatPrice, getFileName } from "utils";
import { v1 as uuid } from "uuid";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { saveAssignedToForAllItem, saveConsolidatedPOFlag, saveOrderAttachments, setAttachmentList } from "Store/Component/FleetManagement/FleetManagementAction";
import { selectors as purchaseOrderSelectors } from "../../../../../../redux/PurchaseOrder";
import { setOnManageEquipConsolidatedChecked, setOnNonstandardConsolidatedChecked, setOnVehicleConsolidatedChecked, updateCostCenter, updateCostCenterResponse } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import purchaseOrderOperation from "../../../../../../redux/PurchaseOrder/operations";

const LeaderOrderDetailContainer = (props: any) => {
    const { isBulkOrder = false } = props
    const dispatch = useDispatch();

    const {
        getUserDetails,
        orderDetails,
        isCostCenterUpdated,        
        docList,
        attachmentsList,
        linkedAttachment,
        isVehicleConsolidatedChecked,
        isManageEquipConsolidatedChecked,
        isNonstandardConsolidatedChecked,
        purchaseOrderStepperDataArr,
        savedStatus,
        fleetItemPurchaseDetailsSave,
        assignTo,
        assignedForAllItem
    }: any = useSelector((state:any)=>({
        getUserDetails: state.UserProfile.getUserDetails,
        orderDetails: selectors.getOrderDetail(state),
        isCostCenterUpdated : state.FleetProcessingReducer.isCostCenterUpdated,        
        docList: state.UploadAttachmentsReducer.list,
        attachmentsList: state.fleetAdminTaskReducer.attachmentList,
        linkedAttachment: state.fleetAdminTaskReducer.linkedAttachments,
        isVehicleConsolidatedChecked : state.FleetProcessingReducer.isVehicleConsolidatedChecked,
        isManageEquipConsolidatedChecked : state.FleetProcessingReducer.isManageEquipConsolidatedChecked,
        isNonstandardConsolidatedChecked : state.FleetProcessingReducer.isNonstandardConsolidatedChecked,
        purchaseOrderStepperDataArr: purchaseOrderSelectors.getPurchaseOrderStepperData(state),
        savedStatus: state.adminTaskReducer.savedStatus,
        fleetItemPurchaseDetailsSave: state.fleetAdminTaskReducer?.fleetItemPurchaseDetailsSave,
        assignTo: purchaseOrderSelectors.getAssignToDropdown(state),
        assignedForAllItem: state.fleetAdminTaskReducer?.assignedForAllItem,
    }))

    const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
    const [branchValue, setBranchValue] = useState<any>({});
    const [oldBranchValue, setOldBranchValue] = useState<any>({});
    const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);
    const [attachmentError, setAttachmentError] = useState<string>("");
    const [documentList, setDocumentList] = useState<any>([]);
    const [iAttachmentEditable, setIsAttachmentEditable] = useState<any>();
    const [isAssignedToChecked, setIsAssignedToChecked] = useState<any>(false);
    const [assignedToForAllValue, setAssignedToForAllValue] = useState<any>();
    const dispatchStepperDataArr = purchaseOrderOperation.dispatchSetPurchaseorderStepperInfo(dispatch);
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
    });
    const [updateOrderAttachments, setUpdateOrderAttachments] = useState<boolean>(false)

    useEffect(() => {
        setBranchValue({ value: orderDetails?.costCenter, label: orderDetails?.costCenter, text: orderDetails?.costCenter });
    }, [orderDetails])

    useEffect(() => {
        setIsAssignedToChecked(orderDetails?.isLockedBy)
        setAssignedToForAllValue(orderDetails?.lockedBy)
    }, [orderDetails?.isLockedBy, orderDetails?.lockedBy])

    useEffect(() => {
        if(!isCostCenterUpdated && isCostCenterUpdated != undefined){
            orderErrorResponsePopUp();
            updateCostCenterResponse(undefined);
        }
    }, [isCostCenterUpdated])
    useEffect(() => {
      setDocumentList(docList)
    },[])

    useEffect(() => {
        return () => {
          dispatch(setOnVehicleConsolidatedChecked(""))
          dispatch(setOnManageEquipConsolidatedChecked(""))
          dispatch(setOnNonstandardConsolidatedChecked(""))
        };
      }, []);

    const orderErrorResponsePopUp = () => {
        const popUpDecriptionTxt = (
          <>
            <p>Error occured while changing branch.</p>
          </>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: CONSTANTS.TITLE_CONFIRMATION,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: popUpDecriptionTxt,
          primaryBtnText: "",
          outlineBtnText: "Close",
          popupOutlinebtnOnclick: ()=>{
            setBranchValue(oldBranchValue);
            setOldBranchValue({});
            hideDialog();
          },
          isSingleConfirmationBtn: true,
        });
      }

    const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    }
    useEffect(() => {
        if(orderDetails?.orderRequestId && updateOrderAttachments){
            let payload = {
                orderId: orderDetails?.orderRequestId,
                attachments: docList,
                savedBy: getUserDetails?.emailId
            }
            dispatch(saveOrderAttachments(payload))
            setUpdateOrderAttachments(false)
        }
        dispatch(setAttachmentList(docList));
    }, [docList]);
    useEffect(() => {
        if(orderDetails){
            let orderAttachment = orderDetails?.orderAttachments?.length > 0 ? JSON.parse(JSON.stringify(orderDetails?.orderAttachments)) : [];
            UploadAttachmentsDispatch.dispatchSetAttachments(dispatch)(orderAttachment);
        }
    }, [orderDetails])

    useEffect(() => {
        ///To disable the uploader after (creating PO/CIP pool) for all
        const val = savedStatus?.filter((savedItem?: any) => savedItem?.orderStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED)
        if (val?.length || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED) {
            setIsAttachmentEditable(false)
        }else{
            setIsAttachmentEditable(true)
        }
    }, [orderDetails, savedStatus])

    useEffect(()=>{
        if(assignedForAllItem?.response){
            const assignedForAllItemArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
            const data = assignedForAllItemArr?.map((item : any) => {
                if(assignedForAllItem?.payload?.fleetItemIds?.includes(item.fleetRequestDetailId))
                    return {
                        ...item,
                        'assignedTo' : assignedForAllItem?.payload?.assignedTo
                    }
                else 
                    return {
                        ...item
                    }
            })
            dispatchStepperDataArr(data)
        }
    },[assignedForAllItem])

    const isUploaded = (name: string) =>
        attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

    const onUploadClick = (fileList: Array<File>) => {
        setAttachmentError("");
        const filteredList = [
            ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
        ];
        if (filteredList.length > 0 && filteredList.length <= 5) {
            setAttachmentError("");
            let totalSize = 0;
            filteredList.forEach((file: File) => {
                totalSize = totalSize + (file.size || 0);
            });
            if (totalSize <= 5000000) {
                setAttachmentError("");
                const formData = new FormData();
                formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

                for (const element of filteredList) {
                    formData.append("Files", element as any);
                }
                dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
                setUpdateOrderAttachments(true)
            } else {
                setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
            }
        } else if (fileList.length > 5) {
            setAttachmentError(
                "Please Upload files without exceeding maximum limit of 5 files"
            );
        } else {
            if (fileList.length > 0 && !filteredList.length) {
                setAttachmentError("All files are uploaded try to add new files");
            } else {
                setAttachmentError("Choose at least 1 file to upload");
            }
        }
    };

    const onRemoveAttachment = (index: any) => {
        const findattachment = attachmentsList?.find((_attachment: any, i: any) => index === i);
        const assetArr = [];
        if (findattachment) {
            for(let i = 0; i < linkedAttachment?.length; i++){
                linkedAttachment[i]?.attachments?.forEach((assetVal: any) => {
                    const findAttch = (assetVal?.fileName === findattachment?.fileName);
                    if (findAttch) {
                        assetArr.push(assetVal)
                      }
                })
            }
            
        }
        if (assetArr?.length) {
            setAttachmentError("The attachment file cannot be deleted. File linked to the item.");
        }
        else {
            const newArr = attachmentsList.slice();
            newArr.splice(index, 1);
            const newFileList = [...documentList];
            newFileList.splice(index, 1);
            setDocumentList(newFileList);
            dispatchRemoveAttachment(newArr);
            setAttachmentError("");
            setUpdateOrderAttachments(true)
        }
    }
    const CreateVehicleConsolidatedChecked = (e: any) => {
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let ConsolidatedPoData : any = []
        let consolidatedFleetIds: any = []
        if (e.target.checked){
            dispatch(setOnVehicleConsolidatedChecked(CONSTANTS.VEHICLE_REQUEST))

            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item?.poNumber){
                  consolidatedFleetIds.push(item?.fleetRequestDetailId)  
                  const purchaseData = {...item, createUniquePO: true}
                    return {...purchaseData}   
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: true,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
        else{
            dispatch(setOnVehicleConsolidatedChecked(""))
            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item?.poNumber){
                    consolidatedFleetIds.push(item?.fleetRequestDetailId)
                    const purchaseData = {...item, createUniquePO: false}
                    return {...purchaseData} 
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: false,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
    }

    const CreateManageEquipConsolidatedChecked = (e: any) => {
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let ConsolidatedPoData : any = []
        let consolidatedFleetIds: any = []
        if (e.target.checked){
            dispatch(setOnManageEquipConsolidatedChecked(CONSTANTS.MANAGED_EQUIPMENT))
            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item?.poNumber){
                    consolidatedFleetIds.push(item?.fleetRequestDetailId)
                    const purchaseData = {...item, createUniquePO: true}
                    return {...purchaseData}
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: true,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
        else{
            dispatch(setOnManageEquipConsolidatedChecked(""))

            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item?.poNumber){
                    consolidatedFleetIds.push(item?.fleetRequestDetailId)
                    const purchaseData = {...item, createUniquePO: false}
                    return {...purchaseData}
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: false,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
    }

    const CreateNonStandardConsolidatedChecked = (e: any) => {
        const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
        let ConsolidatedPoData : any = []
        let consolidatedFleetIds: any = []
        if (e.target.checked){
            dispatch(setOnNonstandardConsolidatedChecked(CONSTANTS.NON_STANDARD_EQUIPMENT))

            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item?.poNumber){
                    consolidatedFleetIds.push(item?.fleetRequestDetailId)
                    const purchaseData = {...item, createUniquePO: true}
                    return {...purchaseData} 
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: true,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
        else{
            dispatch(setOnNonstandardConsolidatedChecked(""))

            ConsolidatedPoData = saveConsolidatedPoDataArr?.map((item : any) => {
                if(item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item?.poNumber){
                    consolidatedFleetIds.push(item?.fleetRequestDetailId)
                    const purchaseData = {...item, createUniquePO: false}
                    return {...purchaseData}
                }
                return item
            })
            dispatchStepperDataArr(ConsolidatedPoData)
            dispatch(saveConsolidatedPOFlag({
                createUniquePO: false,
                fleetIds: consolidatedFleetIds,
                savedBy: getUserDetails?.emailId
            }))
        }
    }
    
    const [isVehicleChecked, setIsVehicleChecked] = useState(false);
    const [isEquipmentChecked, setisEquipmentChecked] = useState(false);
    const [isNonStandardChecked, setIsNonStandardChecked] = useState(false);

    useEffect(() => {
        let vehicleCount = 0;
        let managedEquipCount = 0;
        let NonStdEquipCount = 0;
        purchaseOrderStepperDataArr?.map((item: any) => {
            if (item?.orderRequestType == CONSTANTS.VEHICLE_REQUEST) {
                if (item?.createUniquePO) {
                    dispatch(setOnVehicleConsolidatedChecked(CONSTANTS.VEHICLE_REQUEST))
                }
                if (item?.poNumber || item?.pocipDetails) {
                    vehicleCount = vehicleCount + 1
                }
            }
            else if (item?.orderRequestType == CONSTANTS.MANAGED_EQUIPMENT) {
                if (item?.createUniquePO) {
                    dispatch(setOnManageEquipConsolidatedChecked(CONSTANTS.MANAGED_EQUIPMENT))
                }
                if (item?.poNumber || item?.pocipDetails) {
                    managedEquipCount = managedEquipCount + 1
                }
            }
            else if (item?.orderRequestType == CONSTANTS.NON_STANDARD_EQUIPMENT) {
                if (item?.createUniquePO) {
                    dispatch(setOnNonstandardConsolidatedChecked(CONSTANTS.NON_STANDARD_EQUIPMENT))
                }
                if(item?.poNumber || item?.pocipDetails) {
                    NonStdEquipCount = NonStdEquipCount + 1
                }
            }
        })
        if (vehicleCount > 0) {
            setIsVehicleChecked(true)
        } else {
            setIsVehicleChecked(false)
        }
        if (managedEquipCount > 0) {
            setisEquipmentChecked(true)
        } else {
            setisEquipmentChecked(false)
        }
        if (NonStdEquipCount > 0) {
            setIsNonStandardChecked(true)
        } else {
            setIsNonStandardChecked(false)
        }
    }, [purchaseOrderStepperDataArr])

    const getTotal = useCallback(() => {
        if(fleetItemPurchaseDetailsSave?.hasOwnProperty('totalAmount')){
            return formatPrice(fleetItemPurchaseDetailsSave?.totalAmount ? fleetItemPurchaseDetailsSave?.totalAmount : 0, 2)
        } else{
            return formatPrice(orderDetails?.grandTotal ? orderDetails?.grandTotal : 0, 2)
        }
    },[orderDetails, fleetItemPurchaseDetailsSave])

    const getOrderQty = useCallback(() => {
        return Number(orderDetails?.quantity || 0).toString()
    }, [orderDetails])

    const onAssignedToToggleChange = (e?: any) => {
        e.preventDefault();
        if (assignedToForAllValue?.length > 0) {
            const fleetItemIds:any = []
            purchaseOrderStepperDataArr.forEach((item:any) => {
                if(item.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && item.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE){
                    fleetItemIds.push(item.fleetRequestDetailId)
                }
            });
            let payload = {
                orderId: orderDetails?.orderRequestId,
                fleetItemIds: e.target.checked ? fleetItemIds : [],
                isAssignedToForAll: e.target.checked,
                assignedTo: assignedToForAllValue,
                savedBy: getUserDetails?.emailId
            }
            dispatch(saveAssignedToForAllItem(payload))
            setIsAssignedToChecked(e.target.checked)
        }else{
            setIsAssignedToChecked(e.target.checked)
        }
    }

    const onAssignedToDropdownChange = (e?: any, item?:any) => {
        setAssignedToForAllValue(item.value)
        const fleetItemIds:any = []
        purchaseOrderStepperDataArr.forEach((item:any) => {
            if(item.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && item.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE){
                fleetItemIds.push(item.fleetRequestDetailId)
            }
        });
        let payload = {
            orderId: orderDetails?.orderRequestId,
            fleetItemIds: fleetItemIds,
            isAssignedToForAll: true,
            assignedTo: item?.value,
            savedBy: getUserDetails?.emailId
        }
        dispatch(saveAssignedToForAllItem(payload))
    }

    return <LeadrOrderDetail 
        orderDetails={orderDetails} 
        branchValue={branchValue}
        Popupcontent={Popupcontent}
        hideDialog={hideDialog}
        onUploadClick = {onUploadClick}
        onRemoveAttachment = {onRemoveAttachment}
        setAttachmentError = {setAttachmentError}
        attachmentError = {attachmentError}
        setDocumentList = {setDocumentList}
        documentList = {documentList}
        attachmentsList = {attachmentsList}
        CreateVehicleConsolidatedChecked={CreateVehicleConsolidatedChecked}
        CreateManageEquipConsolidatedChecked={CreateManageEquipConsolidatedChecked}
        CreateNonStandardConsolidatedChecked={CreateNonStandardConsolidatedChecked}
        isVehicleConsolidatedChecked={isVehicleConsolidatedChecked}
        isManageEquipConsolidatedChecked={isManageEquipConsolidatedChecked}
        isNonstandardConsolidatedChecked={isNonstandardConsolidatedChecked}
        isVehicleChecked={isVehicleChecked}
        isEquipmentChecked={isEquipmentChecked}
        isNonStandardChecked={isNonStandardChecked}
        iAttachmentEditable = {iAttachmentEditable}
        isBulkOrder={isBulkOrder}
        key={orderDetails?.orderRequestId}
        getTotal = {getTotal}
        getOrderQty = {getOrderQty}
        assignTo = {assignTo}
        onAssignedToToggleChange = {onAssignedToToggleChange}
        onAssignedToDropdownChange = {onAssignedToDropdownChange}
        isAssignedToChecked = {isAssignedToChecked}
        assignedToForAllValue = {assignedToForAllValue}
    />
}

export default LeaderOrderDetailContainer